import React from "react";

// @material-ui/core
// core components
import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import CertInfoCard from "components/Card/CertInfoCard";

export default function Backup() {
  return (
    <div>
      <Grid container spacing={3}>
        <CertInfoCard/>
      </Grid>
    </div>
  );
}
